module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KvOy2X/images/cover.jpg?1733085655492",
      "alt": "This image is the cover for the book Wisdom of Gibran, Wisdom"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wisdom of Gibran, Wisdom\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('b', [_vm._v("An A-to-Z guide to the mystic poet’s maxims and aphorisms")]), _vm._v(" An early twentieth-century Lebanese-American writer, Khalil Gibran instilled his poetry and art with his experiences in both the East and West. This selection of quotes, maxims, and aphorisms is drawn from such poems as “Secrets of the Heart,” “Spirits Rebellious,” and “Broken Wings,” as well as from his autobiography and essays. Gibran’s words express a strong spirituality and mysticism and his voice offers a direct and at times optimistic view of the brotherhood of man. Addressing everything from love and death to Jesus, motherhood, and nature, Gibran’s wisdom remains thought provoking and inspirational."), _c('p'), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      , Joseph Sheban\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v(" Khalil Gibran (1883–1931) was a Lebanese-American essayist, novelist, and mystic poet. He wrote "), _c('i', [_vm._v("The Prophet")]), _vm._v(", a collection of philosophical essays that went on to become one of the bestselling books of the twentieth century. Though he was born in Lebanon, he moved to Boston’s South End as a child and studied art with Rodin in Paris for two years before launching his literary career. Much of Gibran’s work contains themes of religion and Christianity as well as spiritual love. Gibran died in New York City in 1931.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Philosophical Library\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0